import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from '../../../contexts/AuthContext'
import TablaProveedores from "./TablaProveedores";
import { Button, Row, Table, Badge, Modal, ModalHeader, ModalBody, ModalFooter, Input, Label } from "reactstrap";
import Header from "../../../layout/Header/Header";
import axios from "axios";
import Swal from "sweetalert2";
import SelectorArchivos, { subirEnSerie, avisaResultado } from "../../SelectorArchivos";

// D07 (checklist 21 OCT): sin constancia fiscal (o equivalente internacional) no se pide anticipo
const esConstancia = (a) => a.tipo === "Constancia fiscal";


function ListadoProveedores() {
  const { user } = useContext(AuthContext);
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const [proveedores, setProveedores] = useState([]);
  const [provArchivos, setProvArchivos] = useState(null);
  const [tipoDoc, setTipoDoc] = useState("Constancia fiscal");
  const [archivosNuevos, setArchivosNuevos] = useState([]);
  const [subiendo, setSubiendo] = useState(false);
  const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };

  function abreArchivos(p) {
    setProvArchivos(p);
    setArchivosNuevos([]);
    setTipoDoc((p.archivos || []).some(esConstancia) ? "Otro" : "Constancia fiscal");
  }

  function reemplaza(actualizado) {
    setProveedores((lista) => lista.map((x) => (x._id === actualizado._id ? actualizado : x)));
    setProvArchivos(actualizado);
  }

  async function subeDocumentos() {
    if (!archivosNuevos.length) return;
    setSubiendo(true);
    const resultado = await subirEnSerie(
      archivosNuevos,
      (archivo, nombre) => {
        const formData = new FormData();
        formData.append("file", archivo);
        formData.append("nombre", nombre);
        formData.append("tipo", tipoDoc);
        formData.append("user", `${user.nombre} ${user.apellido}`);
        return axios.post(`${URL_PROVEEDORES}Archivo/${provArchivos._id}`, formData, { headers });
      },
      "Subiendo documentos del proveedor"
    );
    setSubiendo(false);
    if (resultado.ultimaRespuesta && resultado.ultimaRespuesta.data) reemplaza(resultado.ultimaRespuesta.data);
    setArchivosNuevos(archivosNuevos.filter((f) => resultado.fallidos.some((x) => x.nombre === (f.webkitRelativePath || f.name))));
    avisaResultado(resultado, tipoDoc === "Constancia fiscal" ? "Ya se pueden pedir anticipos a este proveedor." : "");
  }

  function quitaDocumento(a) {
    Swal.fire({
      title: `Quitar ${a.nombre}?`,
      text: esConstancia(a) ? "Si es la unica constancia fiscal, ya no se podran pedir anticipos" : "",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Si, quitar",
      cancelButtonText: "Cancelar",
    }).then((r) => {
      if (!r.isConfirmed) return;
      axios
        .delete(`${URL_PROVEEDORES}Archivo/${provArchivos._id}/${a._id}`, { headers })
        .then((res) => reemplaza(res.data))
        .catch((error) =>
          Swal.fire({ icon: "error", title: "No se pudo quitar", text: error.response?.data?.message || "" })
        );
    });
  }

  useEffect(() => {
    axios
      .get(`${URL_PROVEEDORES}Tipo/China`, { 
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allProveedores = response.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });
  },[]);

  return (
    <>     
     <Header />
    <br />
    <br />
    {user.menu_proveedores  ?(
        <div className="card col-12">
          <Row>
              {user.proveedores_create  ?(
              <Button size="sm" type="submit" className="btn btn-success" href="/ProveedoresCreate">Nuevo Proveedor</Button>
              ):(
                <Button size="sm" type="submit" className="btn btn-success" disabled>Nuevo Proveedor</Button>
              )}
              <Button
              size="sm"
              href="/MenuCompras"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
            </Row>
                <h3 align="center">Proveedores</h3>
                <Table size="sm" striped borderless className="table-responsive-xl">
                  <thead>
                    <tr>
                      <th className="tituloTabla">
                        Codigo
                      </th>
                      <th className="tituloTabla">
                        Nombre Comercial
                      </th>
                      {/* <th className="tituloTabla">
                        Razon Social
                      </th> */}
                      <th className="tituloTabla">
                        Contacto
                      </th>
                      <th className="tituloTabla">
                        Telefono
                      </th>
                      <th className="tituloTabla">
                        Email
                      </th>
                      <th className="tituloTabla">
                        Editar
                      </th>
                      <th className="tituloTabla" title="Obligatoria para pedir anticipos">
                        Constancia fiscal
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    {proveedores.map((p) => {
                      return (
                        <tr>
                          <TablaProveedores
                            codigo={p.codigo}
                            nomcom={p.nombre_comercial}
                            // razsoc={p.razon_social}
                            RFC={p.RFC}
                            contacto={p.contacto}
                            telefono={p.telefono}
                            email={p.email}
                            _id={p._id} is_active={p.is_active}
                            calle={p.calle}
                            numero_ext={p.numero_ext}
                            numero_int={p.numero_int}
                            delegacion={p.delegacion}
                            estado={p.estado}
                            pais={p.pais}
                            cp={p.cp}
                            colonia={p.colonia}
                            moneda={p.moneda}
                            anticipo={p.anticipo}
                            tiempoEntrega={p.tiempoEntrega}
                            diasProduccion={p.diasProduccion}
                            diasTransito={p.diasTransito}
                            diasDespacho={p.diasDespacho}
                            ciudad={p.ciudad}
                            idProveedor={p._id}
                            cargos={p.cargos}
                            abonos={p.abonos}
                            saldo={p.saldo}
                          />
                          <td style={{ whiteSpace: "nowrap" }}>
                            {(p.archivos || []).some(esConstancia) ? (
                              <Badge color="success" pill title="Tiene constancia fiscal: se le pueden pedir anticipos">
                                Si
                              </Badge>
                            ) : (
                              <Badge color="danger" pill title="Sin constancia fiscal: no se le pueden pedir anticipos">
                                Falta
                              </Badge>
                            )}{" "}
                            <Button
                              size="sm"
                              color="info"
                              title="Documentos del proveedor (constancia fiscal y otros)"
                              onClick={() => abreArchivos(p)}
                            >
                              <i class="fas fa-paperclip"></i>
                              {(p.archivos || []).length ? ` ${(p.archivos || []).length}` : ""}
                            </Button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
        </div>
      ): undefined } 

      <Modal size="lg" isOpen={!!provArchivos} toggle={() => !subiendo && setProvArchivos(null)}>
        <ModalHeader toggle={() => !subiendo && setProvArchivos(null)}>
          Documentos de {provArchivos && provArchivos.nombre_comercial}
        </ModalHeader>
        <ModalBody>
          {provArchivos && !(provArchivos.archivos || []).some(esConstancia) ? (
            <div style={{ fontSize: 13, color: "#991b1b", marginBottom: 10 }}>
              <i class="fas fa-ban"></i> Sin constancia fiscal no se le pueden pedir anticipos. Si el proveedor es
              extranjero, sube el documento fiscal equivalente de su pais (Business License, Tax ID, etc.) marcado
              como Constancia fiscal.
            </div>
          ) : null}
          <Table size="sm" borderless striped>
            <thead>
              <tr>
                <th>Archivo</th>
                <th>Tipo</th>
                <th>Fecha</th>
                <th>Subio</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {((provArchivos && provArchivos.archivos) || []).map((a) => (
                <tr key={a._id}>
                  <td style={{ wordBreak: "break-all" }}>
                    <a href={a.url} target="_blank" rel="noopener noreferrer" title="Abrir o descargar">
                      {a.nombre}
                    </a>
                  </td>
                  <td>
                    <Badge color={esConstancia(a) ? "success" : "secondary"} pill>
                      {a.tipo || "Otro"}
                    </Badge>
                  </td>
                  <td>{a.fecha}</td>
                  <td style={{ fontSize: 12 }}>{a.user}</td>
                  <td>
                    {user.proveedores_create ? (
                      <Button size="sm" color="danger" title="Quitar este documento" onClick={() => quitaDocumento(a)}>
                        <i class="fas fa-trash"></i>
                      </Button>
                    ) : null}
                  </td>
                </tr>
              ))}
              {provArchivos && !(provArchivos.archivos || []).length ? (
                <tr>
                  <td colSpan={5} style={{ color: "#94a3b8" }}>
                    Todavia no tiene documentos
                  </td>
                </tr>
              ) : null}
            </tbody>
          </Table>
          <Label>Tipo de documento</Label>
          <Input type="select" value={tipoDoc} onChange={(e) => setTipoDoc(e.target.value)} style={{ maxWidth: 260 }}>
            <option value="Constancia fiscal">Constancia fiscal (o equivalente)</option>
            <option value="Otro">Otro</option>
          </Input>
          <div className="mt-2">
            <SelectorArchivos archivos={archivosNuevos} onChange={setArchivosNuevos} deshabilitado={subiendo} />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            color="success"
            disabled={!archivosNuevos.length || subiendo}
            title="Subir los archivos elegidos con el tipo seleccionado"
            onClick={subeDocumentos}
          >
            {subiendo ? "Subiendo..." : "Subir"}
          </Button>
          <Button color="secondary" disabled={subiendo} onClick={() => setProvArchivos(null)}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ListadoProveedores;
